<template>
    <div v-auto-animate>
        <template v-if="open === false">
            <button
                type="submit"
                @click="openConfirm()"
                :disabled="disabled"
                :title="$t('messages.delete')"
                class="inline-flex items-center px-1.5 py-1.5 border border-transparent text-xs font-medium rounded focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                :class="
                    disabled
                        ? 'text-gray-700 bg-gray-100 cursor-default'
                        : 'cursor-pointer text-indigo-700 bg-indigo-100 hover:bg-indigo-200'
                "
            >
                <svg viewBox="0 0 20 20" fill="currentColor" class="trash w-4 h-4">
                    <path
                        fill-rule="evenodd"
                        d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                        clip-rule="evenodd"
                    ></path>
                </svg>
            </button>
        </template>
        <template v-else>
            <div class="flex space-x-2 items-center">
                <div>
                    {{ $t('messages.are_you_sure?') }}
                </div>
                <div class="flex space-x-2 items-center">
                    <form :action="href" method="post" @submit.prevent="submit">
                        <button
                            type="submit"
                            class="text-indigo-700 bg-indigo-100 hover:bg-indigo-200 inline-flex items-center px-1.5 py-1.5 border border-transparent text-xs font-medium rounded focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                        >
                            <svg
                                class="w-4 h-4"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    fill-rule="evenodd"
                                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                    clip-rule="evenodd"
                                ></path>
                            </svg>
                        </button>
                    </form>
                    <button
                        type="button"
                        @click="open = false"
                        class="text-indigo-700 bg-indigo-100 hover:bg-indigo-200 inline-flex items-center px-1.5 py-1.5 border border-transparent text-xs font-medium rounded focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    >
                        <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                            <path
                                fill-rule="evenodd"
                                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                clip-rule="evenodd"
                            ></path>
                        </svg>
                    </button>
                </div>
            </div>
        </template>
    </div>
</template>
<script>
export default {
    name: 'InertiaInlineSquareDeleteButton',
    emits: ['deleted'],
    props: {
        href: {
            type: String,
            required: true,
        },
        confirmText: {
            type: String,
        },
        confirm: {
            type: Boolean,
            default: true,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            open: false,
        };
    },
    methods: {
        submit() {
            this.$inertia.delete(this.href, {
                preserveScroll: true,
                onSuccess: () => {
                    this.$emit('deleted');
                },
            });
        },
        openConfirm() {
            this.open = true;
        },
    },
};
</script>
